import React from 'react'
import './marker-read.scss'

const MarkerRead: React.FC<{ read: boolean }> = (props) => {
  return <div className={`marker ${props.read === false ? 'blue' : ''}`}></div>
}

export default MarkerRead
